import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { configure } from 'axios-hooks';
import { getInstance } from 'api';
import { MainPage, ServiceEndedPage } from './pages';
import { theme } from './theme';

configure({ axios: getInstance() });

const SERVICE_END_DATE = new Date('2026-07-01');

const App: React.FC = () => {
  const isServiceEnded = new Date() > SERVICE_END_DATE;

  return (
    <ChakraProvider theme={theme}>
      <Router>
        <Switch>
          {isServiceEnded ? (
            <Route path="/" component={ServiceEndedPage} />
          ) : (
            <Route path="/:alias?" component={MainPage} />
          )}
        </Switch>
      </Router>
    </ChakraProvider>
  );
};

export default App;
